const ptbr = {
    menuAction: {
        item_1: "INÍCIO",
        item_2: "SOBRE",
        item_3: "HABILIDADES",
        item_4: "TECNOLOGIAS",
        item_5: "EXPERIÊNCIAS"
    },
    salutation: {
        item_1: "Olá",
        item_2: "Eu sou o Gui Oliveira",
        item_3: "Engenheiro de Software",
        item_4: "UX/UI Design"
    },
    about: {
        item_1: "Sobre",
        item_2: "Sou formado em Engenharia Mecatrônica pela Universidade Tiradentes com especialização em Desenvolvimento de Software. Possuo ampla experiência em desenvolvimento web e mobile, atuo como Frontend Web Developer. Hábil na utilização do React para criar soluções web inovadoras, também sou versado em Mapbox e Leaflet. Possuo proficiência em UX/UI e na criação de telas e soluções digitais usando Figma.",
        item_3: "SAIBA MAIS"
    },
    skills: {
        item_1: "Habilidades",
        item_2: "Front-end",
        item_3: "Metodologias Ágeis",
        item_4: "Nível Inglês",
        item_5: "UX/UI Design",
        item_6: "Back-end",
        item_7: "Soft Skills"
    },
    tecnologies: {
        item_1: "Tecnologias"
    },
    expirience: {
        item_0: {
            item_0_1: "Experiência"
        },
        item_1: {
            item_1_1: "BACHARELADO EM ENGENHARIA MECATRÔNICA",
            item_1_2: "Universidade Tiradentes (UNIT)",
            item_1_3: "Superior",
            item_1_4: "fev/2016 - out/2021"
        },
        item_2: {
            item_2_1: "DESENVOLVIMENTO DE SOFTWARE FULLSTACK",
            item_2_2: "Cubos Academy",
            item_2_3: "Profissional",
            item_2_4: "abr/2022 - nov/2022"
        },
        item_3: {
            item_3_1: "GESTÃO ÁGIL DE PROJETOS",
            item_3_2: "Biopark Educação",
            item_3_3: "Trainee",
            item_3_4: "abr/2023 - nov/2023"
        },
        item_4: {
            item_4_1: "ANALISTA DE T.I",
            item_4_2: "Prefeitura de Jabotão dos Guararapes",
            item_4_3: "• Responsável por fornecer suporte técnico a todas as escolas do sistema de educação incluindo anexos da prefeitura. Também era parte do escopo da minha função, solucionar problemas de hardware, software e configuração de equipamentos de rede. Como líder da equipe de TI implementei metodologias para melhoria continua dos estoques de peças e serviços.",
            item_4_4: "mar/2020 - jun/2022"
        },
        item_5: {
            item_5_1: "DESENVOLVEDOR MOBILE JR.",
            item_5_2: "Tascom Tecnologia",
            item_5_3: "• Minha função foi no desenvolvimento frontend do app de acompanhamento médico domiciliar. Participei de resoluções de problemas de programação, codeview e testes. A experiência aumentou meu nível de percepção de como funciona uma equipe de alto rendimento, aprendizado técnico e habilidades de comunicação.",
            item_5_4: "out/2022 - abr/2023"
        },
        item_6: {
            item_6_1: "ENGENHEIRO DE SOFTWARE JR.",
            item_6_2: "3DGEO",
            item_6_3: "• Responsável por todas as etapas relacionadas a concepção visual, compatibilidade e interação do aplicativo com o usuário na ponta. Sendo Head Dev, ocupei cargo de liderança técnica, opinando diretamente nas tecnologias empregadas durante o desenvolvimento do projeto.",
            item_6_4: "abr/2023 - ..."
        },
        item_7: {
            item_7_1: "BAIXAR CURRICULO"
        }
    },
    footer: {
        item_1: "Copyright ⓒ2024 Todos os direitos reservados."
    }
}

const eng = {
    menuAction: {
        item_1: "HOME",
        item_2: "ABOUT",
        item_3: "SKILLS",
        item_4: "TECHNOLOGIES",
        item_5: "EXPERIENCES"
    },
    salutation: {
        item_1: "Hello",
        item_2: "I'm Gui Oliveira",
        item_3: "Software Engineer",
        item_4: "UX/UI Design"
    },
    about: {
        item_1: "About",
        item_2: "I hold a degree in Mechatronics Engineering from Tiradentes University with specialization in Software Development. I have extensive experience in web and mobile development, working as a Frontend Web Developer. Proficient in using React to create innovative web solutions, I'm also well-versed in Mapbox and Leaflet. I have proficiency in UX/UI and in creating screens and digital solutions using Figma.",
        item_3: "LEARN MORE"
    },
    skills: {
        item_1: "Skills",
        item_2: "Front-end",
        item_3: "Agile Methodologies",
        item_4: "English Level",
        item_5: "UX/UI Design",
        item_6: "Back-end",
        item_7: "Soft Skills"
    },
    technologies: {
        item_1: "Technologies"
    },
    experience: {
        item_0: {
            item_0_1: "Experience"
        },
        item_1: {
            item_1_1: "BACHELOR'S DEGREE IN MECHATRONICS ENGINEERING",
            item_1_2: "Universidade Tiradentes (UNIT)",
            item_1_3: "Undergraduate",
            item_1_4: "Feb/2016 - Oct/2021"
        },
        item_2: {
            item_2_1: "FULLSTACK SOFTWARE DEVELOPMENT",
            item_2_2: "Cubos Academy",
            item_2_3: "Professional",
            item_2_4: "Apr/2022 - Nov/2022"
        },
        item_3: {
            item_3_1: "AGILE PROJECT MANAGEMENT",
            item_3_2: "Biopark Educação",
            item_3_3: "Trainee",
            item_3_4: "Apr/2023 - Nov/2023"
        },
        item_4: {
            item_4_1: "IT ANALYST",
            item_4_2: "Jaboatão dos Guararapes City Hall",
            item_4_3: "• Responsible for providing technical support to all schools in the education system including municipal annexes. It was also within the scope of my role to troubleshoot hardware, software, and network equipment configuration issues. As the IT team leader, I implemented methodologies for continuous improvement of parts and services inventories.",
            item_4_4: "Mar/2020 - Jun/2022"
        },
        item_5: {
            item_5_1: "JUNIOR MOBILE DEVELOPER",
            item_5_2: "Tascom",
            item_5_3: "• My main role was the frontend development of the residential medical monitoring app programmed in React Native for the Android platform. I participated in programming issue resolutions, code reviews, and testing. The experience increased my perception of how a high-performance team works, technical learning, and communication skills.",
            item_5_4: "Oct/2022 - Apr/2023"
        },
        item_6: {
            item_6_1: "JUNIOR SOFTWARE ENGINEER",
            item_6_2: "3DGEO",
            item_6_3: "• Responsible for all stages related to the visual conception, compatibility, and user interaction of the app. As the Head Dev, I held a technical leadership position, directly influencing the technologies employed during the project development.",
            item_6_4: "Apr/2023 - ..."
        },
        item_7: {
            item_7_1: "DOWNLOAD RESUME"
        }
    },
    footer: {
        item_1: "Copyright ⓒ2024 All rights reserved."
    }
}

module.exports = {
    ptbr,
    eng
}